/**
 * @copyright 2023 Honda Motor Co., Ltd. All rights reserved.
 */

export const REGISTER_TASK = "Register";
export const EDIT_TASK = "Edit";

export const PHASE_SELECT_TASK = "Select Task";
export const PHASE_SELECT_JOB = "Select Job";
export const PHASE_TASK_SETTING = "Setting";
export const PHASE_TASK_CONFIRM = "Confirm";

/** Process: Select Task > Select Job > Setting > Confirm */
export const NEW_NODES_TASK_REGISTER_PROCESSES = [
  PHASE_SELECT_TASK,
  PHASE_SELECT_JOB,
  PHASE_TASK_SETTING,
  PHASE_TASK_CONFIRM,
];
/** Process: Select Task > Setting > Confirm */
export const EXITS_NODES_TASK_REGISTER_PROCESSES = [
  PHASE_SELECT_TASK,
  PHASE_TASK_SETTING,
  PHASE_TASK_CONFIRM,
];
/** Process: Select Job > Setting > Confirm */
export const NO_TASK_LIST_PROCESSES = [
  PHASE_SELECT_JOB,
  PHASE_TASK_SETTING,
  PHASE_TASK_CONFIRM,
];
/** Process: Confirm */
export const APPROVE_ONLY_PROCESSES = [PHASE_TASK_CONFIRM];

export interface TaskControlState {
  process: Array<string>;
  processTitles: Array<string>;
  phase: number;
}

export const headerHeight = "85px";
export const footerHeight = "55px";
